import { Children, cloneElement } from 'react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithResponsive: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => {
    const child = Children.only(children);

    return cloneElement(child, {
        className: `${child?.props?.className || ''} ${styles.withResponsive} ${className}`,
        testId
    });
};

export default WithResponsive;
